import { fetchEntities } from 'actions/entities';
import ContactForm from 'components/contacts/ContactForm'
import EntitiesMenu from 'components/entities/EntitiesMenu';
import dotProp from 'dot-prop'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getContacts } from 'selectors/contacts'

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getContacts('menu')(state),
    entityName: 'contact',
    item: (props) => <div>{`${props.contact.firstName} ${props.contact.lastName}`}</div>,
    form: ContactForm,
    loading: state.meta?.contact?.loading,
    error: state.meta?.contact?.error,
    totalPages: dotProp.get(state, 'meta.contact.keyWindows.byWindow.menu.totalPages'),
    activePage: dotProp.get(state, 'meta.contact.keyWindows.byWindow.menu.page'),
    confidentialityButton: true
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch((dispatch, getState) => {
        let activePage = dotProp.get(getState(), 'meta.contact.keyWindows.byWindow.menu.page')
        if (!activePage) dispatch(fetchEntities('contacts', { name: 'menu', page: 1, append: true }))
      })
    },
    onLoadMore: (activePage, totalPages) => {
      if( activePage < totalPages ) {
        dispatch(fetchEntities('contacts', { name: 'menu', filter: {}, page: activePage + 1, append: true }))
      }
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu));
